"use client";

import { ThemeProvider } from "@emotion/react";
import { ReactNode } from "react";
import { theme } from "@/styles/theme";

export default function ClientProviders({ children }: { children: ReactNode }) {
  return (
    <>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </>
  );
}

{
  /* <CacheProvider value={clientSideEmotionCache}></CacheProvider> */
}
